import { render, staticRenderFns } from "./CookiePolicyView.vue?vue&type=template&id=833db550&"
import script from "./CookiePolicyView.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports